import { Controller } from '@hotwired/stimulus';

export default class AdminStatisticsController extends Controller {
  connect(): void {
    import('chartkick/chart.js');
  }
}
